import { Helmet } from 'react-helmet-async';

import ProjectEditorContainer from '../../components/project/ProjectEditorContainer';
import WriteActionButtonsContainer from '../../components/project/WriteActionButtonsContainer';
import TagBoxContainer from '../../components/project/TagBoxContainer';
import HeaderContainer from '../../components/common/HeaderContainer';

const ProjectWritePage = () => {
    return (
        <>
            <Helmet>
                <title>Write Project</title>
            </Helmet>
            <HeaderContainer />
            <ProjectEditorContainer />
            <TagBoxContainer />
            <WriteActionButtonsContainer />
        </>
    );
};

export default ProjectWritePage;
